import client from './apiClient';
import {
  TraceContextLogViewModel,
  TraceContextLogSummaryViewModel,
  SearchTraceLogRequest,
} from '../models/feeTracing';

export const searchTraceLogs = async (type: string = 'Fees', params: SearchTraceLogRequest = {}): Promise<TraceContextLogSummaryViewModel[]> => {
  const { data } = await client.post<TraceContextLogSummaryViewModel[]>(`/trace-logs/${type}/search`, params);
  return data;
};

export const getTraceById = async (transactionId: string): Promise<TraceContextLogViewModel[]> => {
  const { data } = await client.get<TraceContextLogViewModel[]>(`/trace-logs/${transactionId}`);
  return data;
};

export const getFileContent = async (fileRecordId: string): Promise<string> => {
  const { data } = await client.get<string>(`/files/${fileRecordId}/content`, {
    responseType: 'text',
    transformResponse: [(data) => data],
  });
  return data;
};
